export const SPONSOR_NODE = 'SPONSOR_NODE';
export const HEARING_NODE = 'HEARING_NODE';
export const LINK_NODE = 'LINK_NODE';
export const NEWS_STORY_NODE = 'NEWS_STORY_NODE';
export const TWEET_NODE = 'TWEET_NODE';
